import React, { useState, useEffect } from "react";

const PetPremium = ({ ...props }) => {
  const [data, setData] = useState({
    dogs: [],
    cats: [],
  });

  useEffect(() => {
    const petPremiumAmount = {
      dogs: [
        { breed: "Poodle", age: "8 wks - 6 yrs", premium: "Php 4,752.00" },
        { breed: "", age: "7 yrs - 9 yrs", premium: "Php 7,032.00" },
        { breed: "Shih Tzu", age: "8 wks - 6 yrs", premium: "Php 6,192.00" },
        { breed: "", age: "7 yrs - 9 yrs", premium: "Php 8,472.00" },
      ],
      cats: [
        { breed: "Ragdoll", age: "8 wks - 6 yrs", premium: "Php 4,752.00" },
        { breed: "", age: "7 yrs - 9 yrs", premium: "Php 7,032.00" },
        {
          breed: "Persian",
          age: "8 wks - 6 yrs",
          premium: "Php 6,192.00",
        },
        {
          breed: "",
          age: "7 yrs - 9 yrs",
          premium: "Php 8,472.00",
        },
      ],
    };

    setData(petPremiumAmount);
  }, []);

  return (
    <div className="max-w-md p-5 max-w-full bg-white shadow rounded-lg">
      <div>
        <h2 className="text-gray-800 text-sm font-bold leading-snug">
          Pet Health Insurance Sample Premium Table
        </h2>

        <h4 className="mt-5 text-sm font-bold">Dogs (1-year Coverage)</h4>
        <div className="relative border border-gray-200 mt-1 p-3 rounded">
          <div className="flex mb-2">
            <div className="flex-1 text-left">
              <span className="text-md font-bold">Breed</span>
            </div>
            <div className="flex-1 text-center">
              <span className="text-md font-bold">Age</span>
            </div>
            <div className="flex-1 text-right">
              <span className="text-md font-bold">Premium</span>
            </div>
          </div>
          {data.dogs.map((dog, index) => (
            <div key={index} className="flex mb-2">
              <div className="flex-1 text-left">
                <span className="text-sm font-bold">{dog.breed}</span>
              </div>
              <div className="flex-1 text-center">
                <span className="text-sm">{dog.age}</span>
              </div>
              <div className="flex-1 text-right">
                <span className="text-sm">{dog.premium}</span>
              </div>
            </div>
          ))}
        </div>

        <h4 className="mt-5 text-sm font-bold">Cats (1-year Coverage)</h4>
        <div className="relative border border-gray-200 mt-1 p-3 rounded">
          <div className="flex mb-2">
            <div className="flex-1 text-left">
              <span className="text-md font-bold">Breed</span>
            </div>
            <div className="flex-1 text-center">
              <span className="text-md font-bold">Age</span>
            </div>
            <div className="flex-1 text-right">
              <span className="text-md font-bold">Premium</span>
            </div>
          </div>
          {data.cats.map((cat, index) => (
            <div key={index} className="flex mb-2">
              <div className="flex-1 text-left">
                <span className="text-sm font-bold">{cat.breed}</span>
              </div>
              <div className="flex-1 text-center">
                <span className="text-sm">{cat.age}</span>
              </div>
              <div className="flex-1 text-right">
                <span className="text-sm">{cat.premium}</span>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-3 text-xs font-bold text-gray-500">
          Note: Premium depends on the pet's breed.
        </p>
      </div>
    </div>
  );
};

export default PetPremium;
